export default __webpack_public_path__ + "static/produkty-e4baa6f7436932c65f2d00ca45adef7f.jpg";